export const HANDOFF_TASK_STATUSES: string[] = ['SENT_TO_LEAD_PARTNER'];
